import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "url(#a)",
  d: "M10.245 8.955 12 9.6l-1.755.645L9.6 12l-.645-1.755L7.2 9.6l1.755-.645L9.6 7.2zM7.597 1.803a.3.3 0 0 1 .176.033c.054.03.095.077.118.132a.25.25 0 0 1 .006.173l-.982 3.072h1.813a.3.3 0 0 1 .149.043q.068.043.1.115a.25.25 0 0 1-.051.284l-4.363 4.462a.278.278 0 0 1-.454-.084.25.25 0 0 1-.006-.173l.982-3.073H3.272a.3.3 0 0 1-.149-.043.27.27 0 0 1-.1-.115.25.25 0 0 1 .051-.284l4.364-4.462a.28.28 0 0 1 .159-.08m-4.552-.048L4.8 2.4l-1.755.645L2.4 4.8l-.645-1.755L0 2.4l1.755-.645L2.4 0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "a",
    x1: "0",
    x2: "13.053",
    y1: "0",
    y2: "1.283",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#D45AFF" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#40F"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }